import { Helmet } from 'react-helmet-async';
// components
import Header from '@/components/Layout/components/Header';
import Filters from '@/pages/Workflow/components/Filters';
import Main from '@/pages/Workflow/components/Main';
// utils
import { GENERAL_MANAGER_AGENT_NAME } from '@/const';
import { useTopicsQuery } from '@/services/akb/akb.queries.ts';
import { usePersonasQuery } from '@/services/bff/bff.queries.ts';
// assets
import styles from '@/pages/Workflow/Workflow.module.css';
import { useCustomerAttributeQuery } from '@/services/customer/customer/customer.queries.ts';

const Workflow = () => {
    const { data: agents } = usePersonasQuery({
        page: 1,
        per: 100,
        is_linked_to_agent: true,
        name: GENERAL_MANAGER_AGENT_NAME
    });

    const { data: attribute } = useCustomerAttributeQuery(
        'project_attributes_scenario'
    );

    const generalManager = (agents?.items ?? []).find(
        (agent) => agent.name === GENERAL_MANAGER_AGENT_NAME
    );

    const { data } = useTopicsQuery({
        persona_id: generalManager?.id,
        page: 1,
        per: 1000
    });

    return (
        <>
            <Helmet>
                <title>NEWO - Workflow</title>
            </Helmet>
            <Header breadcrumbs={[{ label: 'Workflow' }]} />

            <div className={styles.content}>
                <Filters
                    items={data?.items ?? []}
                    projectAttributesScenario={attribute?.value.trim()}
                />
                <Main items={data?.items ?? []} />
            </div>
        </>
    );
};

export default Workflow;
